import http from '@/http-common'
import DownloadFile from "../DownloadFile"
import global from "../../utils/global";

export default {
  name: 'FileDocument',
  components: {DownloadFile},
  props: {
    ekp_id: {
      type: Number,
      default: null
    },
    docTypeCode: {
      type: String,
      default: null
    },
    checkDate: true,
    fileType: {
      type: String,
      default: '.pdf'
    },
    pathStr: {
      type: String,
      default: null,
    },
    apipath: {
      type: String,
      default: null,
    },
    forSite: {
      type: Boolean,
      default: false,
    },
    columnsDoc: {
      type: Array,
      default: () => [
        {key: 'docType', label: 'Тип документа'},
        {key: 'nameDoc', label: 'Наименование документа'},
        {key: 'dateDoc', label: 'Дата документа'},
        {key: 'commentDoc', label: 'Комментарий документа'},
        // {key: 'link', label: ''},
        {key: 'edit_field', label: ''},
      ],
    },
    isCalled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedDoc: {id: 0},
      modalLoadOpened: false,
      file: null,
      documents: [],
      validDocument: {
        count: true,
        doc: true,
        date: true,
        form: true,
      },
      modalPdfDialogOpened: false,
      dfileDocument: '',
      // downloadDocument: '',
      activeIndexDoc: -1,
      typeList: [],
      fileObj: {
        keyFile: '',
        dfileDocument: ''
      },
    }
  },
  created() {
    this.loadDocuments()
    if (!this.forSite) {
      this.loadTypesDoc()
    }
  },
  watch: {
    'fileObj.keyFile': function (val) {
      this.editDocRow(val)
    }
  },
  methods: {
    loadDocuments() {
      const vm = this;
      const filter = this.docTypeCode ? '&typeCode=' + this.docTypeCode : '';
      http.get('/' + this.apipath + '/' + this.ekp_id + '?forSite=' + this.forSite + filter)
      .then((response) => {
        if (response.data && response.data !== "") {
          vm.documents = response.data;
        } else {
          vm.documents = []
        }
      })
      .catch((error) => {
        console.log(error.response.message)
      });
    },
    loadTypesDoc() {
      const vm = this;
      let filter = this.docTypeCode ? '?typeCode=' + this.docTypeCode : '';
      http.get('/workkind/DOC_TYPE/list' + filter)
      .then((response) => {
        vm.typeList = []
        response.data.forEach(function (x) {
          var rec = {}
          rec.value = x.id;
          rec.text = x.name;
          vm.typeList.push(rec);
        })
      })
      .catch((error) => console.log(error.response.data));
    },
    checkDocuments() {
      var vm = this;
      for (var key in this.validDocument) {
        vm.validDocument[key] = true;
      }
//                if (this.documents.length == 0) {
//                    vm.validDocument.count = false;
//                    vm.validDocument.form = false;
//                }
      this.documents.forEach(function (x) {
        //noinspection JSAnnotator
        if (!x.nameDoc || x.nameDoc === '') {
          vm.validDocument.doc = false;
          vm.validDocument.form = false;
          return;
        }
        if (!x.dateDoc && vm.checkDate) {
          vm.validDocument.date = false;
          vm.validDocument.form = false;
          return;
        }
      })
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    saveDocuments() {
      this.checkDocuments();
      const vm = this;
      let filterCode = vm.docTypeCode ? '?typeCode=' + vm.docTypeCode : '';
      console.log(filterCode)
      if (this.validDocument.form) {
        http.post('/' + this.apipath + '/save/' + this.ekp_id + filterCode, this.documents)
        .then(() => {
          vm.$emit('closeDialog');
        })
        .catch(error => {
          if (error.response.status === 403) {
            alert("Нет прав!")
          } else {
            alert(error.message)
          }
        });
      }
    },
    showLoadDialog(item, index) {
      this.selectedDoc = JSON.parse(JSON.stringify(item));
      this.activeIndexDoc = index;
      let vm = this;
      vm.selectedDoc = JSON.parse(JSON.stringify(item));
      vm.fileObj.keyFile = global.getStrEmptyOrNull(vm.selectedDoc.keyFile)
      vm.$refs.pdfModal.openModal()
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    editDocRow(val) {
      this.selectedDoc.keyFile = val
      this.documents[this.activeIndexDoc].keyFile = val;
    },
    deleteRowDoc(index) {
      this.documents.splice(index, 1)
    },
    addFileRow() {
      let doc = {
        id: 0,
        keyFile: Date.now().toString(),
        ekpDataId: this.ekp_id,
        nameDoc: '',
        dateDoc: global.getFormattedDate(new Date()),
        docTypeId: null
      }
      this.documents.push(doc);
    },
    downloadFile(rec) {
      global.downloadFile(this.pathStr, rec, this.file, 'pdf')
    }
  }
}
